import { ref } from 'vue'
import { defineStore } from 'pinia'

const flashMessageTimeouts = {
  info: 8 * 1000,
  warning: 10 * 1000,
  error: 12 * 1000
};

// built for use in a v-snackbar-queue
class FlashMessage {
  constructor(level, message) {
    this.color = level;
    this.text = message;
    this.store = useFlashStore();
    this.timeout = flashMessageTimeouts[level];
  }

  remove() {
    this.store.remove(this);
  }

  onDismiss() {
    this.remove();
  }
}

export const useFlashStore = defineStore('flash', () => {
  const messages = ref([]);

  function $reset() {
    messages.value = [];
  }

  function remove(msg) {
    const index = messages.value.findIndex(m => m == msg);
    messages.value.splice(index, 1);
  }

  function info(msg) {
    messages.value.push(new FlashMessage('success', msg));

  }

  function warning(msg) {
    messages.value.push(new FlashMessage('warning', msg));
  }

  function error(msg) {
    messages.value.push(new FlashMessage('error', msg));
  }

  return {
    messages,
    $reset,
    info,
    warning,
    error,
    remove
  };
});
